module.exports = __webpack_public_path__ + "img/zhujihua.1b47fc3a.jpg";